import { useState } from 'react';

import hamburgerIcon from '../../assets/svgs/hamburgerIcon.svg';
import xIcon from '../../assets/svgs/xIcon.svg';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { CustomIcon } from '../widgets/CustomIcon';
import { NavigationItem, NavigationItems } from './NavigationItems';

type NavigationProps = {
  title?: string;
  items: NavigationItem[];
  handleCloseModal?: (clicked: boolean, option: string) => void;
};

export const NavigationBar = ({
  title,
  items,
  handleCloseModal
}: NavigationProps) => {
  const isMobile = useMediaQuery('(max-width: 920px)');

  const [showItems, setShowItems] = useState(true);

  const handleShowItems = () => {
    setShowItems((prev) => !prev);
  };

  return (
    <>
      {isMobile ? (
        <header className="tw-bg-[#F8F8F8] tw-flex tw-flex-col tw-w-full tw-h-auto">
          <div className="tw-flex">
            {title ? (
              <h1 className="tw-font-bold tw-text-[#001E64] tw-py-5 tw-px-4">
                {title}
              </h1>
            ) : null}

            {/* <button onClick={handleShowItems}>
              {!showItems ? (
                <CustomIcon src={hamburgerIcon} />
              ) : (
                <CustomIcon src={xIcon} color="#ffff" />
              )}
            </button> */}
          </div>

          <NavigationItems
            items={items}
            isShowing={showItems}
            handleCloseModal={handleCloseModal}
          />
        </header>
      ) : (
        <aside className="tw-bg-[#F8F8F8] tw-min-w-[14rem] tw-w-[14rem] tw-flex tw-flex-col">
          {title ? (
            <h1 className="tw-font-bold tw-text-[#001E64] tw-py-5 tw-px-4">
              {title}
            </h1>
          ) : null}

          <NavigationItems items={items} />
        </aside>
      )}
    </>
  );
};
